<template>
  <div class="lcu-iphone-spacer" v-if="_device.iPhone && _device.app"></div>
</template>

<script>
export default {
  name: 'iphone-bar',
};
</script>

<style scoped lang="scss">
.lcu-iphone-spacer {
  background-color: $legacy-primary;
  color: $white;
  display: none;
  height: 55px;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 3;

  @include ipad-pro-12 {
    display: block;
    height: 25px;
  }

  @media only screen and (max-width: $mobile-max) {
    display: block;
  }
}
</style>
